import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";

import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { withRouter } from "react-router-dom";
import { useStyles } from "./Count.css";

const StyledBadge = withStyles((theme) => ({
  badge: {
    color: "#0a1f3a",
    backgroundColor: "#eee",
  },
}))(Badge);

class CartCount extends Component {
  handleCart = () => {
    this.props.history.push("/cart");
  };

  render() {
    const { classes } = this.props;
    return (
      <div onClick={this.handleCart} className={classes.cartStyle}>
        <IconButton disableRipple>
          <StyledBadge max={10} badgeContent={this.props.badgeContent}>
            <ShoppingCartIcon style={{ color: "#eee" }} />
          </StyledBadge>
        </IconButton>
        <div className={classes.sectionDesktop}>
          <label>My Cart</label>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(CartCount));
